import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NavigationLink from '@app/common/navigation/navigation-link';
import { TitledBlock } from '@app/common/titled-block/titled-block';
import { AiLogo } from '@modules/ai/common/ai-logo/ai-logo';
export function AIDisabledIDES() {
    return (_jsxs(TitledBlock, { title: "AI Enterprise", titleLogo: _jsx(AiLogo, {}), children: ["AI Enterprise offers AI-powered features within JetBrains IDEs for developers in your organization.", _jsx("br", {}), "Enable the product on the", ' ', _jsx(NavigationLink, { href: "/configuration/license-activation", children: "License & Activation" }), ' ', "page."] }));
}
